export type QueryValue = string | number | boolean | null | undefined;

export function boundedInteger(
  value: number | undefined,
  fallback: number,
  minimum: number,
  maximum: number,
): number {
  if (!Number.isFinite(value)) return fallback;
  return Math.min(maximum, Math.max(minimum, Math.trunc(value as number)));
}

export function boundedText(value: string | undefined, maximum = 200): string | undefined {
  if (value == null) return undefined;
  const normalized = value.trim().slice(0, maximum);
  return normalized || undefined;
}

export function pathSegment(value: string): string {
  return encodeURIComponent(value.slice(0, 200));
}

export function withQuery(path: string, values: Record<string, QueryValue>): string {
  const params = new URLSearchParams();
  for (const [key, value] of Object.entries(values)) {
    if (value !== undefined && value !== null && value !== '') {
      params.set(key, String(value));
    }
  }
  const query = params.toString();
  return query ? `${path}?${query}` : path;
}
